import getDealerSuppliersApi from '@/api/get/company/sales-flow/get-dealer-suppliers';
import Loader from '@/components/loader/loader-component';
import { useQuery } from '@/hooks/use-api';
import { Heading1Text } from '@/utils/global-fonts';
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_CONTEXT } from '@/utils/context';
import SalesWrapper from '../../sales-flow-manager-style';
import Styled from './select-supplier-style';

const Header = {
  marginTop: '32px',
};

// FIRST STEP
/**
 * Select supplier
 * @returns {JSX.Element}
 */
const SelectSupplier = () => {
  const [suppliers, setSuppliers] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const { setShowSideNav } = useContext(APP_CONTEXT);
  const { data, loading } = useQuery(getDealerSuppliersApi);

  const navigate = useNavigate();

  const goToSelectProductCategory = (supplier) => {
    navigate('/shop/sales/select-product-category', {
      state: {
        suppliers,
        selectedSupplier: supplier,
        data,
      },
    });
  };

  const handleSelectSupplier = (supplier) => {
    setSelectedSupplier(supplier);
    goToSelectProductCategory(supplier);
  };

  useEffect(() => {
    setShowSideNav(false);
    return () => setShowSideNav(true);
  }, [setShowSideNav]);

  useEffect(() => {
    if (!suppliers && !loading) {
      setSuppliers(data.suppliers);
    }
  }, [suppliers, data, setSuppliers, loading]);

  return (
    <SalesWrapper>
      {loading ? (
        <Loader loading />
      ) : (
        <Styled.Container>
          <Heading1Text style={suppliers?.length > 6 ? Header : null}>
            Choose a Supplier
          </Heading1Text>
          <Styled.SupplierRow>
            {suppliers?.map((supplier) => (
              <Styled.SupplierWrapper
                sm={6}
                md={4}
                lg={4}
                xl={3}
                xxl={3}
                key={supplier.id}
              >
                <Styled.Supplier
                  selected={supplier?.id === selectedSupplier?.id}
                  onClick={() => {
                    handleSelectSupplier(supplier);
                  }}
                >
                  <Styled.SupplierImageContainer>
                    {supplier.logo ? (
                      <Styled.SupplierLogoImg src={supplier.logo} />
                    ) : (
                      <Styled.SupplierLogoAlternative>
                        client logo
                      </Styled.SupplierLogoAlternative>
                    )}
                  </Styled.SupplierImageContainer>
                  <Styled.SupplierLabel>{supplier?.name}</Styled.SupplierLabel>
                </Styled.Supplier>
              </Styled.SupplierWrapper>
            ))}
          </Styled.SupplierRow>
        </Styled.Container>
      )}
    </SalesWrapper>
  );
};

export default SelectSupplier;
